/**
 * Перекодирует байты банковской выписки в текст. Формат обмена с 1С приходит в
 * Windows-1251 (строка «Кодировка=Windows») или в старой DOS-кодировке
 * («Кодировка=DOS»); какая из них — видно по тому, в какой читается слово «Кодировка».
 */
export function decodeStatementBytes(bytes: ArrayBuffer | Uint8Array): string {
  const win = new TextDecoder('windows-1251').decode(bytes)
  const dos = new TextDecoder('ibm866').decode(bytes)
  if (/^Кодировка\s*=\s*DOS/im.test(dos)) return dos
  // Файл, пересохранённый в UTF-8: в Windows-1251 кириллица превратится в «Р…С…».
  if (!/^Кодировка\s*=/im.test(win)) {
    const utf = new TextDecoder('utf-8').decode(bytes)
    if (/^Кодировка\s*=/im.test(utf)) return utf
  }
  return win
}

/** Читает выбранный файл выписки как текст. */
export async function readStatementFile(file: File): Promise<string> {
  return decodeStatementBytes(await file.arrayBuffer())
}
